module.exports = __webpack_public_path__ + "static/media/Administracion7.c71b123.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/Administracion7.mp3
// module id = 714
// module chunks = 1